import { toast } from "react-toastify";
import api from "../../api";

/**
 * Download a paper/exam PDF through the authenticated API client and hand it to the browser.
 * Mirrors the work sheet download in AiAnswerSheetUpload.
 */
export default async function downloadPaperPdf(url, filename) {
  try {
    const response = await api.get(url, { params: { download: 1 }, responseType: "blob" });

    // A JSON body in a blob response means the server refused (403/404).
    if (response.data?.type === "application/json") {
      const text = await response.data.text();
      let message = "Download failed";
      try {
        message = JSON.parse(text)?.message || message;
      } catch (_) {}
      toast.error(message);
      return false;
    }

    // Usually a PDF; pack downloads can be a ZIP.
    const type = response.headers?.["content-type"] || "application/pdf";
    const objectUrl = URL.createObjectURL(new Blob([response.data], { type }));
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch (err) {
    let message = err?.response?.data?.message;
    if (!message && err?.response?.data instanceof Blob) {
      try {
        message = JSON.parse(await err.response.data.text())?.message;
      } catch (_) {}
    }
    toast.error(message || "No PDF is available for this paper yet.");
    return false;
  }
}
